import React from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';

import PrimaryButton from '../buttons/primary/PrimaryButton';
import SecondaryButton from '../buttons/secondary/SecondaryButton';

type ConfirmDialogProps = {
    isOpen: boolean,
    setOpen: (isOpen: boolean) => void,
    title: string,
    message: string,
    handleCancel: () => void,
    handleOk: (event: any) => void
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen, setOpen, title, message, handleCancel, handleOk,
}: ConfirmDialogProps) => (
  <Dialog
    onClose={
      (event, reason) => {
        if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          setOpen(false);
        }
      }
    }
    maxWidth="xs"
    aria-labelledby="confirmation-dialog-title"
    open={isOpen}
  >
    <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
    <DialogContent dividers>
      {message}
    </DialogContent>
    <DialogActions>
      <SecondaryButton onClick={handleCancel} label="Cancel" />
      <PrimaryButton onClick={handleOk} label="OK" />
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
